import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * Friendly empty state: soft icon badge, title, description, optional action.
 */
const EmptyState = ({ icon, title, description, action, color = 'primary', sx }) => (
  <Box
    sx={{
      py: { xs: 6, md: 8 },
      px: 3,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      ...sx,
    }}
  >
    {icon && (
      <Box
        aria-hidden
        sx={{
          width: 72,
          height: 72,
          borderRadius: '22px',
          display: 'grid',
          placeItems: 'center',
          mb: 2.5,
          color: `${color}.main`,
          background: (theme) =>
            `linear-gradient(135deg, ${alpha(theme.palette[color].main, 0.16)} 0%, ${alpha(
              theme.palette[color].main,
              0.05
            )} 100%)`,
          '& svg': { fontSize: 34 },
        }}
      >
        {icon}
      </Box>
    )}
    <Typography variant="h5" sx={{ mb: 0.75 }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420, mb: action ? 3 : 0 }}>
        {description}
      </Typography>
    )}
    {action}
  </Box>
);

export default EmptyState;
